<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="12">
          <div class="page-title">題目列表</div>
        </el-col>
        <el-col :span="4" style="text-align:right;">
          <i style="font-size:20px;cursor: pointer;" @click="onIconClose" class="el-icon-close"></i>
        </el-col>
      </el-row>

      <div class="page-box">
        <el-row :gutter="20" type="flex" class="page-content-row">
          <el-col :span="4">
            <div class="search-text">題目編號</div>
            <el-input v-model="listQuery.questionNoLike" placeholder="請輸入題目編號"></el-input>
          </el-col>
          <el-col :span="4">
            <div class="search-text">題目類型</div>
            <el-select v-model="listQuery.type" placeholder="請選擇題目類型">
              <el-option 
                v-for="item in questionTypes" :key="item.value"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <div class="search-text">課程版本</div>
            <el-select v-model="listQuery.lang" placeholder="請選擇課程版本">
              <el-option
                v-for="item in language" :key="item.value"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-button type="info" class="button-el-el" @click="onSearch">搜尋</el-button>                                                                                                   
          </el-col>
          <el-col :span="3">
            <el-button type="success" class="button-el-el" @click="onReset">清除篩選</el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="info" class="button-el-el" @click="batchSelect">批量選擇</el-button>
          </el-col>
        </el-row>
        <el-table @sort-change="handleSortChange" :data="tableData" style="width: 100%;"
          @selection-change="handleSelectionChange"> <!-- 添加选择变化事件 -->
          <el-table-column type="selection" width="55" align="center"></el-table-column> <!-- 添加复选框列 -->
          <el-table-column v-for="(its, idx) in tableCate" :key="idx" :prop="its.prop" :label="its.label" align="center" :sortable="its.sortable">
          </el-table-column>
           <el-table-column
            prop="createdAt"
            label="最後更新時間"
            align="center">
           <template slot-scope="{row}">
               <span>{{row.updatedAt | formatDateTime}}</span>
           </template>
          </el-table-column>
          <el-table-column
            prop="editor"
            label="最後更新帳號"
            align="center">
           <template slot-scope="{row}">
               <span>{{row.editor}}</span>
           </template>
          </el-table-column>
          <el-table-column label="操作"  align="center">
            <template slot-scope="{ row }">
               <el-button type="text" size="medium" @click="onSelect(row)">選擇</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <!-- 分页 -->
    <Pagination v-show="total > 0" :total="total" :page.sync="listQuery._page" :limit.sync="listQuery._limit" @pagination="clickPagin"/>

    <!-- 删除弹窗 -->
    <deleteDialog titleCh="您確定要刪除此題目嗎？" :centerDialogVisible="centerDialogVisible" @confirmFunction="deleteQuestion" @onCancelButton="centerDialogVisible = false;"></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { level } from "@/biz/static-data";
import { getQuestions, deleteQuestion } from '@/api/question'
import deleteDialog from "@/components/deleteDialog";

export default {
  components: { 
    Pagination, 
    deleteDialog,
    // DialogPreview
  },
  data() {
    return {
      selectedRows: [],
      total: 0,
      level,
      questionTypes: [
        { label: "全部", "value": null },
        { label: "選擇題", value: 0},
        { label: "判斷題", value: 1},
        { label: "填空題", value: 2},
        { label: "算術題(定數)", value: 3},
        { label: "熱點圖", value: 4},
        { label: "文字拖拽", value: 5},
        { label: "連線題", value: 6},
        { label: "圖片拖拽題", value: 7},
        { label: "算術題(變數)", value: 8},
        { label: "文字拖拽(分類)", value: 9},
        { label: "矩陣填空", value: 10},
      ],
      language: [
        { "label": "全部", "value": null }, 
        { "label": "中文", "value": 0 }, 
        { "label": "英文", "value": 1 }
      ],
      listQuery: {
        questionNoLike: null,
        level: null,
        lang: null,
        type: null,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
      tableCate: [
        {label: '題目編號', prop: 'questionNo', sortable: 'custom'},
        {label: '題目類型', prop: 'typeConvert'},
        {label: '課程版本', prop: 'langConvert'},
      ],
      curQuestion: {},

      form: {},
      centerDialogVisible: false,
      previewSwitch: false
    };
  },
  mounted() {
    this.getQuestions();
  },
  methods: {
    onIconClose(){
      this.$emit("iconClose");
    },
    onSelect(row){
        this.$emit('select',row)
    },
    // 批量选择方法
    batchSelect() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('請選擇數據！');
        console.log('请先选择数据:');
        return;
      }

      // 通过事件传递选中的多行数据
      // this.$emit('batch-select', this.selectedRows);
      // 如果需要同时触发单行选择事件（可选）
      this.selectedRows.forEach(row => {
        this.$emit('select', row);
      });
    },
    openDialogPreview(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.previewSwitch = true
    },
    // 处理复选框选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log('选中的行数据:', selection);
    },
    // 处理列表顺序
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getQuestions();
    },
    onReset() {
      this.listQuery = {
        level: null,
        lang: null,
        type: null,
        _page: 1,
        _limit: 10,
      };
      this.getQuestions();
    },
    // 搜索
    onSearch() {
      this.listQuery._page = 1;
      this.getQuestions();
    },
    onAdd(){
      this.$router.push({ path: `/question/add` });
    },
    onEditButton(id) {
      this.$router.push({ path: `/question/${id}/edit` });
    },
    onDetailButton(id) {
      this.$router.push({ path: `/question/${id}` });
    },
    onDeleteButton(row) {
      this.curQuestion = {...row}
      this.centerDialogVisible = true
    },
    // 删除题目
    deleteQuestion() {
      deleteQuestion(this.curQuestion.id)
        .then(() => {
          this.listQuery._page = 1
          this.getQuestions();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        }); 
    },
    clickPagin(listQuery) {
      this.listQuery._page = listQuery.page
      this.listQuery._limit = listQuery.limit

      this.getQuestions()
    },
    getQuestions() {
      let listQuery = {...this.listQuery}
      listQuery._page -= 1
      getQuestions(listQuery).then((v) => {
        v.data.filter(its => {
          its.typeConvert = this.questionTypes[its.type + 1].label
          its.langConvert = this.language[its.lang + 1].label
        })
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      }).catch(err => {
        if (err.response.status === 401) {
          this.getQuestions()
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}

.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
  margin-top: 23px;
}
</style>